import { useMutation } from '@tanstack/react-query';
import { Payments } from '@prisma/client';
import useCalendarSelectedAppointment from '../appointments/useCalendarSelectedAppointment';
import {
  invalidateGroupedPayments,
  invalidatePaymentPaymentsGroups,
} from '../../services/payments';
import { invalidateAppointmentPayments } from '../../services/appointments';
import { invalidateCustomerPayments } from '../../services/user';

function useRefreshPayment(onRefresh?: () => void | Promise<void>) {
  const { openedAppointment, setSelectedAppointmentUpdated } =
    useCalendarSelectedAppointment();

  return useMutation({
    mutationFn: async (payment: Payments) => {
      await invalidatePaymentPaymentsGroups();
      await invalidateGroupedPayments();

      if (openedAppointment) {
        setSelectedAppointmentUpdated(true);
        await invalidateAppointmentPayments(openedAppointment.appointmentId);
      } else if (payment.appointmentId) {
        await invalidateAppointmentPayments(payment.appointmentId);
      }

      const customerId = payment?.customerId;
      if (customerId) await invalidateCustomerPayments(customerId);

      onRefresh?.();
    },
  });
}

export default useRefreshPayment;
